"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyOrder = void 0;
const types_1 = require("@framework/types");
const date = new Date();
exports.emptyOrder = {
    userId: 3,
    addressId: 1,
    orderStatus: types_1.OrderStatus.NOW_IN_DELIVERY,
    orderItems: [],
    createdAt: date.toISOString(),
};
//# sourceMappingURL=empty-order.js.map